import { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDialog } from "../../hooks/useDialog";
import { useToast } from "../../hooks/useToast";
import Content from "../templates/wrapper/Content";
import { AuthContext } from "../../context/authContext";
import ForgotPasswordForm from "../organisms/forms/forgotPassword/ForgotPasswordForm";
import VerificationForm from "../organisms/forms/verification/VerificationForm";

const ForgotPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const { t } = useTranslation();
  const { showToast } = useToast();
  const { showDialog } = useDialog();

  const [otp, setOtp] = useState("");

  const handleGetCode = async ({ otp }) => {
    setOtp(otp);
  };

  const handleRedirectToLogin = () => {
    navigate("/");
  };

  const onSubmit = async (values) => {
    try {
      if (values.password !== values.passwordConfirm) {
        showToast("error", t("forgotPassword.passwordError"));
        return;
      }
      const username = localStorage.getItem("username");
      await authContext.forgotPassword(username, otp, values.password);
      showDialog(
        "",
        t("forgotPassword.successMessage"),
        t("dialog.okey"),
        true,
        "",
        "success",
        handleRedirectToLogin
      );
    } catch (error) {
      showDialog(
        "",
        t("forgotPassword.failureMessage"),
        t("dialog.okey"),
        false
      );
    }
  };

  const handleClickVerifyWithDifferentEmail = () => {
    navigate("/request-code");
  };

  const handleResend = async () => {
    const { formData } = location.state || {};
    const username =
      formData.loginMethod === "email" ? formData.email : formData.phone_number;
    localStorage.setItem("username", username);
    await authContext.sendCode(username);
    showToast("success", t("accountVerification.successMessage"));
  };

  const handleClose = () => {
    navigate(-1);
  };

  return (
    <>
      <Content>
        {otp ? (
          <ForgotPasswordForm onSubmit={onSubmit} />
        ) : (
          <VerificationForm
            title={t("forgotPassword.otpTitle")}
            description={t("forgotPassword.description")}
            showRemoveOnDesktop={true}
            handleGetCode={handleGetCode}
            handleResend={handleResend}
            isPhoneNumberVerification={
              location.state?.formData?.loginMethod === "phone_number"
            }
            handleClickVerifyWithDifferentEmail={
              handleClickVerifyWithDifferentEmail
            }
            handleClose={handleClose}
          />
        )}
      </Content>
    </>
  );
};

export default ForgotPassword;
